import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Order from "pages/secure/facility/order/Order";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  const { authStore } = state;
  return {
    authStore: { ...authStore },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Order);
